import React from 'react';

class End extends React.Component{


	render(){
			return ( 
			  <div className="row custom_row">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 custom_col">
                    <div className="love_web">
                        <p>THANH TUAN WITH LOVE © 2019 ALL RIGHTS RESERVED.</p>
                    </div>
                </div>
            </div>
	    	)
	    }
	}
export default End;